module.exports = "../images/hunting@2x.jpg?v=eac313a";